import React from 'react';
import styles from './RevenueTables.module.scss';
import RevenueVendorExpenseTable from './RevenueVendorExpenseTable/RevenueVendorExpenseTable';
import GstSummaryTable from './GstSummaryTable/GstSummaryTable';
import { GST_SUMMARY_VIEWS } from './GstSummaryTable/constants';
import { GstRangeKey } from '../GstOverview/useGstDateRange';
import { TabModule } from '../../../../utils/constants/commonConstants';

interface RevenueTablesProps {
    tab: string;
    dataSource: any;
    fetchHeadlinePanelData: (isPolling?: boolean) => void;
    rangeKey: GstRangeKey;
    fetchStartDate: string;
    fetchEndDate: string;
    unitDivisor?: number;
}

// rangeKey/fetchStartDate/fetchEndDate are the applied GST "Time Period" range
// (RECUR-27384, owned by useGstDateRange in GstAnalysisPanel) — threaded down
// to both tables so their fetches stay in sync with the toggle/month pickers.
function RevenueTables({
    tab,
    dataSource,
    fetchHeadlinePanelData,
    rangeKey,
    fetchStartDate,
    fetchEndDate,
    unitDivisor = 1,
}: RevenueTablesProps) {
    return (
        <div className={styles.RevenueTables}>
            {tab === TabModule.REVENUE && (
                <GstSummaryTable
                    view={GST_SUMMARY_VIEWS.REVENUE}
                    fetchHeadlinePanelData={fetchHeadlinePanelData}
                    rangeKey={rangeKey}
                    fetchStartDate={fetchStartDate}
                    fetchEndDate={fetchEndDate}
                    unitDivisor={unitDivisor}
                />
            )}
            {tab === TabModule.VENDOR_EXPENSES && (
                <GstSummaryTable
                    view={GST_SUMMARY_VIEWS.EXPENSE}
                    fetchHeadlinePanelData={fetchHeadlinePanelData}
                    rangeKey={rangeKey}
                    fetchStartDate={fetchStartDate}
                    fetchEndDate={fetchEndDate}
                    unitDivisor={unitDivisor}
                />
            )}
            <RevenueVendorExpenseTable
                tab={tab}
                dataSource={dataSource}
                fetchStartDate={fetchStartDate}
                fetchEndDate={fetchEndDate}
                unitDivisor={unitDivisor}
            />
        </div>
    );
}

export default RevenueTables;
